import { t } from "i18next";
import moment from "moment";

import { languageTrans } from "@constants/contactPerson";
import { CONTACT_TYPE } from "@constants/register";
import { ProfileData } from "@models/components/user.model";
import { store } from "@store/index";

import { CONSTANTS } from ".";
export const userProfileData = (data: ProfileData) => {
  const { selectedLanguage } = store.getState().user;

  const firstSectionItems = [
    {
      hideFor: [CONTACT_TYPE.SINGLE],
      key: "companyName",
      label: t("companyName"),
      value: data?.profile?.companyName,
    },
    {
      hideFor: [CONTACT_TYPE.COMPANY_WITHOUT_CONTACT],
      label: t("name"),
      value:
        data?.profile?.firstName && data?.profile?.lastName
          ? `${data?.profile?.firstName} ${data?.profile?.lastName}`
          : "",
    },
    {
      hideFor: [CONTACT_TYPE.COMPANY_WITHOUT_CONTACT],
      label: t("gender"),
      value: t(data?.profile?.gender),
    },
    {
      hideFor: [CONTACT_TYPE.COMPANY_WITHOUT_CONTACT],
      label: t("salutation"),
      value: t(data?.profile?.salutation),
    },
    {
      hideFor: [CONTACT_TYPE.COMPANY_WITHOUT_CONTACT],
      label: t("dateOfBirth"),
      value: data?.profile?.dob
        ? moment(data?.profile?.dob).format(
            CONSTANTS.DATE_FORMATS.DAY_MONTH_YEAR_FORMAT
          )
        : "",
    },
  ];

  const secondSectionItems = [
    {
      label: t("street"),
      value: data?.profile?.street,
    },
    {
      label: t("zipCode"),
      value: data?.profile?.zipcode,
    },
    {
      label: t("city"),
      value: data?.profile?.city,
    },
  ];

  const lastSectionItems = [
    {
      label: t("mainEmail"),
      value: data?.email,
    },
    {
      label: t("PhoneNumber"),
      value: data?.profile?.telephoneNumber,
    },
    {
      label: t("userProfile.language"),
      value:
        t(languageTrans[selectedLanguage]) ||
        t(languageTrans[data?.profile?.language]),
    },
  ];

  return { firstSectionItems, lastSectionItems, secondSectionItems };
};

export const NOTIFICATION = {
  PERMISSION_GRANTED: "granted",
};
